/**
 * 更新浏览器标题和 favicon 的工具函数（H5前端版本）
 * 使用共享的 documentTitle 工具，配置H5前端特定的默认值
 */

import { createDocumentTitleUpdater } from '../shared/utils/documentTitle';

// 创建H5前端专用的更新器
const updater = createDocumentTitleUpdater({
  defaultTitle: '公益捐赠',
  formatTitle: (orgName: string) => orgName, // H5直接显示机构名称
  defaultFavicon: '/favicon.ico',
});

// 导出函数
export const updateDocumentTitle = updater.updateDocumentTitle;
export const updateFavicon = updater.updateFavicon;
export const updateDocumentTitleAndFavicon = updater.updateDocumentTitleAndFavicon;
export const resetDocumentTitleAndFavicon = updater.resetDocumentTitleAndFavicon;

